import { useState } from 'react';
import styles from '../css/CopyrightHolders.module.css';

const Advertise = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    company: '',
    subject: '',
    message: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Advertise form submitted:', formData);
    alert('Заявка отправлена! Мы свяжемся с вами в ближайшее время.');
    setFormData({
      name: '',
      email: '',
      company: '',
      subject: '',
      message: ''
    });
  };

  return (
    <div className={styles.copyrightPage}>
      <div className={styles.container}>
        <h1 className={styles.title}>Рекламодателям</h1>

        <div className={styles.content}>
          <p className={styles.paragraph}>
            DoramaHype — один из крупнейших порталов о дорамах в Казахстане и СНГ.
            Мы предлагаем различные форматы размещения рекламы для продвижения вашего бренда,
            продукта или услуги среди нашей активной аудитории.
          </p>

          <div className={styles.requirements}>
            <h2 className={styles.subtitle}>Форматы рекламы</h2>

            <ul className={styles.list}>
              <li>Баннерная реклама на страницах сайта</li>
              <li>Нативная интеграция в контент</li>
              <li>Спонсорство разделов и подборок</li>
              <li>Размещение в социальных сетях проекта</li>
              <li>Индивидуальные рекламные кампании</li>
            </ul>
          </div>

          <p className={styles.paragraph}>
            По всем вопросам сотрудничества и размещения рекламы свяжитесь с нами:
          </p>

          <p className={styles.email}>
            doramahype@gmail.com
          </p>

          <div className={styles.formSection}>
            <h2 className={styles.subtitle}>Форма обращения</h2>

            <form className={styles.form} onSubmit={handleSubmit}>
              <div className={styles.formGroup}>
                <label htmlFor="name" className={styles.label}>Ваше имя:</label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  placeholder="Ваше имя"
                  className={styles.input}
                  required
                />
              </div>

              <div className={styles.formGroup}>
                <label htmlFor="email" className={styles.label}>Ваш E-Mail:</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder="Ваш E-Mail"
                  className={styles.input}
                  required
                />
              </div>

              <div className={styles.formGroup}>
                <label htmlFor="company" className={styles.label}>Компания:</label>
                <input
                  type="text"
                  id="company"
                  name="company"
                  value={formData.company}
                  onChange={handleChange}
                  placeholder="Название компании"
                  className={styles.input}
                />
              </div>

              <div className={styles.formGroup}>
                <label htmlFor="subject" className={styles.label}>Тема сообщения:</label>
                <input
                  type="text"
                  id="subject"
                  name="subject"
                  value={formData.subject}
                  onChange={handleChange}
                  placeholder="Тема сообщения"
                  className={styles.input}
                  required
                />
              </div>

              <div className={styles.formGroup}>
                <label htmlFor="message" className={styles.label}>Ваше письмо:</label>
                <textarea
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  placeholder="Опишите ваше предложение"
                  className={styles.textarea}
                  rows="8"
                  required
                ></textarea>
              </div>

              <button type="submit" className={styles.submitButton}>
                Отправить заявку
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Advertise;
